export enum second {
  meter = 60,
}
